module.exports = __webpack_public_path__ + "img/iconFacebook.7945549d.svg";